import React, { Component } from 'react';
import moment from 'moment';

export default class QuoteFlowSummary extends Component {
  constructor(props){
    super(props);
  }

  render(){
    return (
      <ul>
       { this.props.steps.map( this.renderSummaryLineItem ) }
      </ul>
    );
  }

  renderSummaryLineItem = ( step, index ) => {
    if( step.SidebarLabel && this.props.getStepVisibleFieldCount(step) > 0) {
      return (
        <li key={ index } className = { step.Input[0] ? this.getIsStepWithInputActiveClass(step.Input[0].Name) : '' }>
          <div>{ step.SidebarLabel }</div>
          { step.Input.map( this.renderInputValue ) }
        </li>
      )
    }
    return null;
  }

  renderInputValue = (input, index) => {
    if(this.props.quoteFormValues[input.Name] && input.InputType.toLowerCase() !== 'hidden' && input.Name.toLowerCase().indexOf('city') === -1){
      return (
        <div className = { this.isZipCodeField(input) ? 'summary-box__zipcode-field': '' } key={ index }>
          { this.getLabelValue(input) }
          { this.renderValueDivider(input) }
        </div>
      );
    }
    return null;
  }

  isZipCodeField = (input) => {
    return  input.Name.toLowerCase().indexOf('zipcode') > -1 ;
  }

  renderValueDivider = (input) => {
    if(input.Name.toLowerCase().indexOf('zipcode') > -1) {
        return (
          <span> - </span>
        )
    }
    return null;
  }

  getLabelValue = (input) => {
    switch (input.InputType.toLowerCase()) {
      case 'radio':
      case 'radiolink':
        return this.getLabelFromInputValue(input);
        break;
      case 'select':
        return this.getLabelFromInputValue(input);
        break;
      case 'text':
        return this.props.quoteFormValues[input.Name];
        break;
      case 'calendar':
        return moment(this.props.quoteFormValues[input.Name]).format('MMMM DD, YYYY') ;
        break;
      default:
          return null;
    }
  }

  getLabelFromInputValue = (input) => {
    let selectedValue = input.Value.find( value => value.Value === this.props.quoteFormValues[input.Name] );
    if((selectedValue && input.Name.toLowerCase() !== "duration") || (selectedValue && input.Name.toLowerCase() === "duration" && this.props.quoteFormValues[input.Name] != 0) ) {
        return selectedValue.Label;
    }
    return null;
  }

  getIsStepWithInputActiveClass = (inputName) => {
      const { steps } = this.props;
      let activeClass = '';
      let firstIncompleteStep = false;
      steps.map( (step, stepIndex) => {
        if ( !firstIncompleteStep && !this.props.stepIsCompleted(step) ){
          firstIncompleteStep = true;
        }
        if(!firstIncompleteStep){
        const matchingInput = step.Input.find( input => input.Name === inputName );
          if( matchingInput && ( step.active && step.completed ) ) {
            activeClass = 'active';
          }
        }
      });
      return activeClass;
  }
}
